module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_bracke-da7a84f0a8a678558ce135aba20518b7.png";